import React, {useEffect, useMemo, useRef, useState} from 'react';
import {FormattedMessage} from "react-intl";

import Currency from "../../../Currency/Currency";

import './CreateYourOwnParlayFooter.style.scss';
import {useDispatch} from "react-redux";
import {updateParlay} from "../../../../stores/pickX/pickX.slice";
import {PayoutModel} from "../../../../constants/PickXEnums";
import useDeviceType from "../../../../hooks/useDeviceType";
import usePreSubmitParlayService from "../../../../services/hooks/usePreSubmitParlayService";
import GlobalConst from "../../../../constants/GlobalConst";

const fees = GlobalConst.CUSTOM_PARLAY.FEES;
const tKey = "lobbyView.contests.customContest.customParlayTable";

const CreateYourOwnParlayFooter = ({parlay, contests, compactMode = false}) => {
    const feeInputRef = useRef(null);
    const focusToFeeInput = () => {
        feeInputRef.current?.focus();
    };

    const dispatch = useDispatch();
    const [isCustomFeeFocused, setIsCustomFeeFocused] = useState(false);
    const [selectedFeeIndex, setSelectedFeeIndex] = useState(0);
    const [selectedEntryFee, setSelectedEntryFee] = useState(0);
    const [selectedContestType, setSelectedContestType] = useState('exact');

    const {isDesktop} = useDeviceType()
    const payoutInfos = useMemo(() => parlay.getPayouts(contests, 0.0), [parlay, contests]);

    const {submitParlay, disableSubmitParlay} = usePreSubmitParlayService({parlay, contests, selectedEntryFee, focusToFeeInput});

    useEffect(() => {
        setSelectedEntryFee(parlay.Wager);
        setSelectedFeeIndex(fees.indexOf(parlay.Wager) + 1);
        setSelectedContestType(parlay.PayoutModel === PayoutModel.Flex ? 'flex' : 'exact');

        if(isDesktop){
            focusToFeeInput()
        }
    }, []);

    const handleFeeChange = (fee, index) => {
        setSelectedEntryFee(fee);
        setSelectedFeeIndex(index);
        parlay.Wager = fee;
        dispatch(updateParlay(parlay.toDto()));
    };
    const handleModeClick = (mode) => {
        setSelectedContestType(mode);
        if (mode === 'flex')
            parlay.PayoutModel = PayoutModel.Flex;
        if (mode === 'exact')
            parlay.PayoutModel = PayoutModel.Exact;
        dispatch(updateParlay(parlay.toDto()));
    };
    const handleSubmitPicksClick = async () => {
        await submitParlay();
    }
    const handleCustomFeeFocus = () => {
        setIsCustomFeeFocused(true)
    }
    const handleCustomFeeBlur = () => {
        setIsCustomFeeFocused(false)
    }

    return (
        <div className={`CreateYourOwnParlayFooter${compactMode ? ' compactMode' : ''}`}>
            <div className="customParlayFooterContent">
                <h4><FormattedMessage id={`${tKey}.entryFees`}/></h4>
                <div className="fees">
                    <input
                        type="text"
                        id="feeInputBar"
                        ref={feeInputRef}
                        className={"feeInputBar " + (selectedFeeIndex === 0 && !isCustomFeeFocused ? 'selected' : '')}
                        value={isCustomFeeFocused ? selectedEntryFee : '$' + selectedEntryFee}
                        onFocus={e => handleCustomFeeFocus()}
                        onBlur={e => handleCustomFeeBlur()}
                        onChange={(e) => handleFeeChange(e.target.value, 0)}
                    />
                    {fees.map((fee, index) => (
                        <button
                            key={fee}
                            className={`feeButton ${selectedFeeIndex === index + 1 ? 'selected' : ''}`}
                            onClick={() => handleFeeChange(fee, index + 1)}>
                            ${fee}
                        </button>
                    ))}
                </div>
                <div className="modeSelector">
                    <button
                        className={`modeButton ${selectedContestType === 'flex' ? 'selected' : ''}`}
                        onClick={() => handleModeClick('flex')}>
                        FLEX
                    </button>
                    <button
                        className={`modeButton ${selectedContestType === 'exact' ? 'selected' : ''}`}
                        onClick={() => handleModeClick('exact')}>
                        EXACT
                    </button>
                </div>
                {payoutInfos.map((payout, index) =>
                    <div key={index}
                         className="payoutInfo">
                        <div>
                            <div className="correct">
                                {payout.correct}/{payout.total} <FormattedMessage id={`${tKey}.correct`}/>
                            </div>
                        </div>
                        <div>
                            <div className="multiplier gold-gradient-border">
                                <div className="gold-gradient-text">x{(payout.multiplier > 100 ? Math.round(payout.multiplier)
                                                                                               : payout.multiplier.toFixed(1).replace(/\.?0+$/, ''))}</div>
                            </div>
                        </div>
                        <div>
                            <span className="payout">
                                <FormattedMessage id={`${tKey}.payout`}/>

                                <Currency currency={parlay.WagerCurrency}
                                          value={payout.payout || 0}
                                          className="gold-gradient-text"/>

                            </span>
                        </div>
                    </div>
                )}
                {<button className={`submitButton ${disableSubmitParlay ? "disabled" : ""}`}
                         disabled={disableSubmitParlay}
                         onClick={handleSubmitPicksClick}
                >
                    <FormattedMessage id={`${tKey}.submitPicks`}/>
                </button>}
            </div>
        </div>
    );
};

export default CreateYourOwnParlayFooter;
